import { createRouter, createWebHashHistory } from "vue-router";
import authRouter from "@/modules/auth/router";
import landingRouter from "@/modules/landing/router";
import profileRouter from "@/modules/profile-managment/router";
import diagnosticRouter from "@/modules/diagnostic/router";
import categoryRouter from "@/modules/course/router/category";
import courseRouter from "@/modules/course/router/course";
import guiaRouter from "@/modules/guia/router/guia";
import NotFound404 from "@/modules/common/pages/NotFound404";
import newsRouter from "@/modules/news/router";
import postsRouter from "@/modules/posts/router";
import directoryRouter from "@/modules/directory/router";
import socialPostsRouter from "@/modules/social-posts/router";

const routes = [
  {
    path: "/",
    ...landingRouter,
  },
  {
    path: "/auth",
    ...authRouter,
  },
  {
    path: "/perfil",
    ...profileRouter,
  },
  {
    path: "/autodiagnostico",
    ...diagnosticRouter,
  },
  {
    path: "/categorias",
    ...categoryRouter,
  },
  {
    path: "/guia-exportadora",
    ...guiaRouter,
  },
  {
    path: "/capacitacion",
    ...courseRouter,
  },
  {
    path: "/noticias",
    ...newsRouter,
  },
  {
    path: "/publicaciones",
    ...postsRouter,
  },
  {
    path: "/redes-sociales",
    ...socialPostsRouter,
  },
  {
    path: "/directorio",
    ...directoryRouter,
  },
  {
    name: "notFound",
    path: "/:pathMatch(.*)*",
    component: NotFound404,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si hay una posición guardada (cuando se usa el botón "atrás" o "adelante"), vuelve a esa posición
    if (savedPosition) {
      return savedPosition;
    } else {
      // Si no hay una posición guardada, desplázate al inicio de la página
      return { top: 0 };
    }
  },
});

// Add navigation guard
// router/index.js

const isCompanyUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const company = JSON.parse(localStorage.getItem("company"));
    return user && company; // Tiene datos de usuario y empresa
  } catch {
    return false;
  }
};

router.beforeEach((to, from, next) => {
  const loggedIn = !!localStorage.getItem("auth_token");
  const companyUser = isCompanyUser();

  // Control de acceso a preguntas del diagnóstico (flujo interno)
  if (
    to.name === "questions" &&
    localStorage.getItem("canAccessQuestions") !== "true"
  ) {
    return next("/autodiagnostico");
  }
  if (to.name === "questions") {
    localStorage.removeItem("canAccessQuestions");
  }

  // Redirección si ya está logeado e intenta ir a login/register
  if ((to.path === "/auth/login" || to.path === "/auth/register") && loggedIn) {
    return next("/");
  }

  // Rutas restringidas solo para usuarios con empresa (logueados sin company → NO PASAN)
  const restrictedCompanyRoutes = [
    //"showDiagnostics", // /autodiagnostico
    //"lista-categorias", // /categorias
    //"categoria-capacitaciones", // /categorias/:name
    //"course-detail", // /capacitacion/:name
  ];

  const isRestricted = restrictedCompanyRoutes.includes(to.name);

  if (loggedIn && isRestricted && !companyUser) {
    return next("/"); // Bloqueo para logeados sin empresa
  }

  next(); // Dejar pasar todo lo demás
});

export default router;
